import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import Nav from './Nav';
import user from '../assets/images/default.png';
import croix from "../assets/images/close.png";
import back from "../assets/images/back.png";
import MenuHeader from './MenuHeader';
import TherapistService from '../services/therapist.service';
import useAxiosPrivate from "../hooks/useApi";
import Modal from "react-modal";
import DateTimeSelector from './DateTimeSelector';
import HeaderTherapist from './HeaderTherapist';
import ReviewList from './ReviewList';
import Informations from './Informations';
import { useNotifications } from '../context/NotificationProvider';
import useAuth from '../hooks/useAuth';
import UserService from '../services/user.service';
import CalendarManagementService from '../services/calendar_management.service';
import GeneralSettingService from '../services/general_setting.service';
import { useTranslation } from 'react-i18next';
import BookingService from "../services/booking.service";
import { formatTimeTo24Hour } from "../shared/utils/string";
import { TextField } from '@mui/material';
import { IconButton, Tooltip, Dialog, DialogTitle, DialogContent, Button, Box, Typography, Avatar } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import PromotionService from "../services/promotion.service";
import PromotionUsageService from "../services/promotion_usage.service";
import InfoIcon from '@mui/icons-material/Info';
import AvailableSlotsService from '../services/available_slots.service';
import { usePrompt } from '../hooks/usePrompt';
import { useTranslatableData } from '../hooks/useTranslatable';

const EDIT_STEP_PATHS = [
  '/choose-products',
  '/choose-flypros'
];

const customStyles = {
  content: {
    width: "33%",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};


Modal.setAppElement("#root");

function formatDisplayDate(date) {
  if (!date) return '';
  const d = typeof date === "string" ? new Date(date) : date;
  return d.toLocaleDateString('fr-FR');
}

function createBookingIdempotencyKey() {
  if (window.crypto?.randomUUID) {
    return `hotel-booking-${window.crypto.randomUUID()}`;
  }

  const randomPart = Math.random().toString(36).slice(2);
  return `hotel-booking-${Date.now()}-${randomPart}`;
}


function ChooseTherapist() {
  const [selectedServices, setSelectedServices] = useState([]);

  const { t, i18n } = useTranslation('therapist');
  // const [selectedTherapist, setSelectedTherapist] = useState(() => {
  //   const state = JSON.parse(sessionStorage.getItem("state") || '{}');
  //   if (state?.selectedTherapist && Array.isArray(state.selectedTherapist)) {
  //     return state.selectedTherapist;
  //   }
  //   return state?.duo ? [] : [];
  // });
  const [therapists, setTherapist] = useState([]);
  const [therapistsOther, setTherapistOther] = useState('');
  const [currentTherapist, setCurrentTherapist] = useState('');
  const [modalIsOpen, setIsOpen] = useState(false);
  const [modalIsOpen2, setIsOpen2] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDateScroll, setSelectedDateScroll] = useState(new Date());
  const [selectedTime, setSelectedTime] = useState(null);
  const [selectedProductIds, setSelectedProductIds] = useState(() => {
    // Initialize from selectedServices
    return selectedServices?.map(s => s?.product?.id).filter(Boolean) || [];
  });
  const [filter, setFilter] = useState(null)
  const [visibleDays, setVisibleDaysCount] = useState(10);
  const [allFlypros, setAllFlypros] = useState([]);
  const [isLoadingFlypros, setIsLoadingFlypros] = useState(false);
  const flyprosFetchedRef = useRef(false);
  const flyprosPromiseRef = useRef(null);
  const [unavailableDates, setUnavailableDates] = useState([]);
  const [availableHours, setAvailableHours] = useState({});
  const [buffertime, setBufferTime] = useState([]);
  const [hasAutoSelected, setHasAutoSelected] = useState(false);
  const [comparisonModalOpen, setComparisonModalOpen] = useState(false);
  const [newBookingPreview, setNewBookingPreview] = useState({});
  // Memoize expensive sessionStorage reads
  const oldBooking = useMemo(() => {
    try {
      return JSON.parse(sessionStorage.getItem('oldBooking') || '{}');
    } catch (e) {
      return {};
    }
  }, []);
  
  const newBooking = useMemo(() => {
    try {
      return JSON.parse(sessionStorage.getItem('state') || '{}');
    } catch (e) {
      return {};
    }
  }, []);
  
  const newBookingPreviewTrans = useTranslatableData(newBookingPreview);
  const oldBookingTrans = useTranslatableData(oldBooking);
  const translatedSelectedServices = useTranslatableData(selectedServices);
  const [bookingSuccess, setBookingSuccess] = useState(false);
  const [isBookingSubmitting, setIsBookingSubmitting] = useState(false);
  const [bookingIdempotencyKey, setBookingIdempotencyKey] = useState(null);
  const [previousSelection, setPreviousSelection] = useState({ date: null, time: null });
  const [firstOpen2, setIsFirstOpen2] = useState(false);
  const daysToShowRef = useRef([]);
  const [daysToShow, setDaysToShow] = useState(() => {
    return [];
  });
  useEffect(() => { daysToShowRef.current = daysToShow; }, [daysToShow]);

  const [bypassPrompt, setBypassPrompt] = useState(false);

  const isEditModeSession =
      !bypassPrompt &&
      sessionStorage.getItem('editBookingMode') === 'true';

  usePrompt(
    isEditModeSession,
    "Êtes-vous sûr de vouloir quitter la modification ? Vos changements ne seront pas enregistrés.",
    next => EDIT_STEP_PATHS.some(p => next.pathname.startsWith(p))
  );

  const [filters, setFilters] = useState({
    with: 'primary_address,zones,media,categories,slots',
    sort: 'firstname'
  });

  const resolveDisplayText = useCallback((value) => {
    if (!value) return '';
    if (typeof value === 'string') return value;
    if (typeof value === 'object') {
      return value[i18n.language] || value.fr || value.en || Object.values(value).find(Boolean) || '';
    }
    return String(value);
  }, [i18n.language]);

  const getServiceDisplayTitle = useCallback((service) => {
    return resolveDisplayText(service?.subCategory?.title)
      || resolveDisplayText(service?.category?.title)
      || resolveDisplayText(service?.product?.category?.title)
      || resolveDisplayText(service?.product?.name)
      || 'Service';
  }, [resolveDisplayText]);
  const location = useLocation();
  const { auth } = useAuth();
  const loc = useLocation();
  const [selectedTherapist, setSelectedTherapist] = useState(() => {
    // Prefer navigation state if present
    if (loc.state && Array.isArray(loc.state.selectedTherapist)) {
      return loc.state.selectedTherapist;
    }
    // Fallback to sessionStorage
    const state = JSON.parse(sessionStorage.getItem("state") || '{}');
    if (state?.selectedTherapist && Array.isArray(state.selectedTherapist)) {
      return state.selectedTherapist;
    }
    return state?.duo ? [] : [];
  });
  const [state, setState] = useState(loc.state || JSON.parse(sessionStorage.getItem('state') ?? '{}'));
  const {
    duo = false,
    room = 'SPA_ROOM',
  } = state || {};

  const [description, setDescription] = useState(state.desc || '')

  // Memoize address data to prevent unnecessary re-renders
  const address = useMemo(() => auth.user?.hotel?.[0]?.address || {}, [auth.user?.hotel]);
  const { longitude, latitude, zip_code } = address;
  const notify = useNotifications();
  const totalDuration = useMemo(() => {
    if (!selectedServices || selectedServices.length === 0) return 0;

    const durations = selectedServices.map(s =>
      s?.product?.duration ? parseInt(s.product.duration, 10) : 0
    );

    if (!duo) {
      // SOLO = sequential sum
      return durations.reduce((a, b) => a + b, 0);
    }

    // DUO pairing logic
    if (durations.length === 2) {
      return Math.max(durations[0] || 0, durations[1] || 0);
    }

    if (durations.length === 4) {
      const therapist1Total = (durations[0] || 0) + (durations[2] || 0);
      const therapist2Total = (durations[1] || 0) + (durations[3] || 0);
      return Math.max(therapist1Total, therapist2Total);
    }

    // Fallback
    const half = Math.ceil(durations.length / 2);
    const therapist1Total = durations.slice(0, half).reduce((a, b) => a + b, 0);
    const therapist2Total = durations.slice(half).reduce((a, b) => a + b, 0);

    return Math.max(therapist1Total, therapist2Total);
  }, [selectedServices, duo]);
  // const totalDuration = selectedServices?.reduce((total, service, index) => {
  //   const duration = service?.product?.duration ? parseInt(service.product.duration, 10) : 0;
  //   return total + duration;
  // }, 0);
  const totalPrice = selectedServices?.reduce((total, service, index) => {
    const price = service?.product?.price ? service.product.price : 0;
    return total + price;
  }, 0);
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();
  const [formData, setFormData] = useState({
    tags: "",
    is_asca: "",
    is_rme: "",
    civility: "",
  });

  const [hydrated, setHydrated] = useState(false);
  const [isLoadingAvailability, setIsLoadingAvailability] = useState(false);
  const [isLoadingTherapists, setIsLoadingTherapists] = useState(false);
  const [promotions, setPromotions] = useState([]);
  const [promoCode, setPromoCode] = useState('');
  const [discountedPrice, setDiscountedPrice] = useState(totalPrice);
  const [alertMessage, setAlertMessage] = useState('');

  const tooltipProps = useMemo(() => ({
    popper: {
      sx: {
        '& .MuiTooltip-tooltip': {
          backgroundColor: '#393d44',
          color: '#fff',
          fontSize: '1rem',
          padding: '8px 12px',
          borderRadius: '8px'
        },
        '& .MuiTooltip-arrow': {
          color: '#393d44',
        }
      }
    }
  }), []);

  // Initialize selectedServices from navigation state or session storage
  useEffect(() => {
    // Priority: navigation state, fallback sessionStorage
    if (loc.state && Array.isArray(loc.state.selectedServices)) {
      setSelectedServices(loc.state.selectedServices);
    } else {
      const sessionState = JSON.parse(sessionStorage.getItem("state") || '{}');
      if (Array.isArray(sessionState.selectedServices)) {
        setSelectedServices(sessionState.selectedServices);
      }
    }
  }, [loc.state]);

  // Sync selectedProductIds when selectedServices changes
  useEffect(() => {
    const productIds = selectedServices?.map(s => s?.product?.id).filter(Boolean) || [];
    setSelectedProductIds(productIds);
  }, [selectedServices]);

  // Initial data fetch after hydration and when we have the required data
  useEffect(() => {
    if (!hydrated || !selectedProductIds.length || !selectedDate || !latitude || !longitude || !zip_code) {
      return;
    }

  }, [hydrated, selectedProductIds, selectedDate, latitude, longitude, zip_code]);

  // 1️⃣  State hydration and therapist fetch (runs once)
  useEffect(() => {
    if (hydrated) return;
    const saved = sessionStorage.getItem('state');
    if (!saved) {
      setHydrated(true);
      return;
    }
    const parsedState = JSON.parse(saved);
    setState(parsedState);

    // Hydrate selectedDate/time/services/therapist from state
    const dateToSet = parsedState.selectedDate || parsedState.date;
    if (dateToSet) {
      const savedDate = new Date(dateToSet);
      // Ensure the saved date is valid and not in the past
      if (!isNaN(savedDate.getTime())) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const savedDateOnly = new Date(savedDate);
        savedDateOnly.setHours(0, 0, 0, 0);

        if (savedDateOnly >= today) {
          setSelectedDate(savedDate);
        } else {
          // If saved date is in the past, use today
          setSelectedDate(today);
        }
      }
    }

    const timeToSet = parsedState.selectedTime || parsedState.time;
    if (timeToSet) setSelectedTime(timeToSet);

    if (Array.isArray(parsedState.selectedTherapist)) setSelectedTherapist(parsedState.selectedTherapist);
    else setSelectedTherapist([]);
    if (Array.isArray(parsedState.selectedServices)) {
      setSelectedProductIds(parsedState.selectedServices.map(s => s?.product?.id).filter(Boolean));
    }

    setHydrated(true);

    // If we have all info, fetch therapists for first render
    const hasAll = parsedState.selectedDate && parsedState.selectedTime && Array.isArray(parsedState.selectedServices) && parsedState.selectedServices.length > 0;
    if (hasAll) {
      const ids = parsedState.selectedServices.map(s => s?.product?.id).filter(Boolean);
      const totalDuration = parsedState.selectedServices.reduce(
        (total, s) => total + (s?.product?.duration ? parseInt(s.product.duration, 10) : 0),
        0
      );
      fetchTherapist(
        formatISODate(new Date(parsedState.selectedDate)),
        parsedState.selectedTime,
        totalDuration,
        longitude,
        latitude,
        zip_code
      );
    }
  }, [hydrated]);


  // 2️⃣  Map selectedTherapist ids to actual therapist objects after fetch
  useEffect(() => {
    if (!hydrated) return;
    if (!therapists.length) return;
    if (!selectedTherapist.length) return;

    const needsMapping = selectedTherapist.some(sel => typeof sel === "number" || (typeof sel === "object" && sel.id && !sel.firstname));

    if (!needsMapping) return;

    const mapped = selectedTherapist
      .map(sel => {
        if (typeof sel === "number") {
          return therapists.find(t => t.id === sel);
        } else if (typeof sel === "object" && sel.id && !sel.firstname) {
          return therapists.find(t => t.id === sel.id);
        }
        return sel;
      })
      .filter(Boolean);

    if (mapped.length === selectedTherapist.length &&
      mapped.some((item, index) => item !== selectedTherapist[index])) {
      setSelectedTherapist(mapped);
    }
  }, [hydrated, therapists]);

  // 3️⃣  Only show "No preference" if nothing else is preselected
  useEffect(() => {
    if (!hydrated) return;
    if (!therapists.length) return;
    if (selectedTherapist.length === 0 && !hasAutoSelected) {
      setSelectedTherapist([{ id: 0 }]);
      setHasAutoSelected(true);
    }
  }, [hydrated, therapists, hasAutoSelected]);

  // 4️⃣  Navigation away if no services
  useEffect(() => {
    if (!hydrated) return;
    if (!selectedServices || selectedServices.length === 0) {
      navigate('/choose-service');
    }
  }, [hydrated, selectedServices, navigate]);

  // 5️⃣  Simplified: Only fetch unavailable dates when essential deps change
  useEffect(() => {
    if (!hydrated) return;
    
    // Debounce to prevent excessive calls
    const timeoutId = setTimeout(() => {
      fetchUnavailableDates();
    }, 100);
    
    return () => clearTimeout(timeoutId);
  }, [hydrated, selectedDate, currentTherapist, modalIsOpen2, daysToShow]); // Removed redundant deps

  const fetchCalendarData = useCallback(async (start, end, therapist = null) => {
    try {
      const params = {
        with: 'therapist.media,therapist.zones,calendars_managements_slots.slot,therapist.categories',
        date: `between:${start},${end}`,
      };

      if (therapist?.id) {
        params.therapist_id = therapist.id;
      }
      const response = await CalendarManagementService.index(
        params,
        axiosPrivate,
        auth?.accessToken ? false : true
      );
      const filteredDates = [];
      response.forEach(entry => {
        if (entry.date && entry.calendars_managements_slots.length > 0 && entry.calendars_managements_slots.some(slot => slot.status === 'AVAILABLE' || slot.status === 'OVER_TIME')) {
          filteredDates.push(entry.date);
        }
      });
      return filteredDates;
    } catch (error) {
      console.error('Erreur lors de la récupération des données du calendrier :', error);
      throw error;
    }
  }, [axiosPrivate, auth?.accessToken]);

  // 6️⃣  Split the massive effect into focused smaller effects
  // Buffer time - fetch once on mount
  useEffect(() => {
    if (!hydrated) return;
    fetchBufferTime();
  }, [hydrated]);

  // Available hours - only when core booking params change  
  useEffect(() => {
    if (!hydrated || !selectedDate || !selectedProductIds.length || !zip_code || !latitude || !longitude) return;
    
    // Debounce to prevent rapid-fire calls
    const timeoutId = setTimeout(() => {
      fetchAvailableHours();
    }, 150);
    
    return () => clearTimeout(timeoutId);
  }, [hydrated, selectedDate, selectedProductIds, zip_code, latitude, longitude, totalDuration]);

  // Days window - only update when date anchor changes
  useEffect(() => {
    if (!hydrated) return;
    updateDaysToShow(selectedDate || selectedDateScroll);
  }, [hydrated, selectedDate, selectedDateScroll]);

  // Therapist fetch - only when we have complete booking info
  useEffect(() => {
    if (!hydrated || !selectedDate || !selectedTime || !selectedProductIds.length || !zip_code || !latitude || !longitude || totalDuration <= 0) return;
    
    // Debounce therapist fetching
    const timeoutId = setTimeout(() => {
      fetchTherapist(
        formatISODate(selectedDate),
        selectedTime,
        totalDuration,
        longitude,
        latitude,
        zip_code
      );
    }, 200);
    
    return () => clearTimeout(timeoutId);
  }, [hydrated, selectedDate, selectedTime, selectedProductIds, totalDuration, longitude, latitude, zip_code]);

  // Initial therapist loading - show all therapists when no date/time selected
  useEffect(() => {
    if (!hydrated || !selectedProductIds.length || !zip_code || !latitude || !longitude) return;
    
    // If no date or no time is selected, show all available therapists in the region
    if (!selectedDate || !selectedTime) {
      const timeoutId = setTimeout(() => {
        handleIfInvalidOrPastDate(selectedDate, selectedTime);
      }, 100);
      
      return () => clearTimeout(timeoutId);
    }
  }, [hydrated, selectedDate, selectedTime, selectedProductIds, zip_code, latitude, longitude]);

  function formatISODate(isoDate) {
    return new Date(isoDate).toLocaleDateString('en-CA').split("T")[0];
  }

  // Validation function for date and time
  const validateDateAndTime = useCallback((date, time) => {
    if (!date || isNaN(date.getTime())) {
      return { isValid: false, message: 'Date invalide' };
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const dateOnly = new Date(date);
    dateOnly.setHours(0, 0, 0, 0);

    if (dateOnly < today) {
      return { isValid: false, message: 'La date ne peut pas être antérieure à aujourd\'hui' };
    }

    if (!time) {
      return { isValid: false, message: 'Heure requise' };
    }

    return { isValid: true };
  }, []);

  function addedTherapist(therapist) {
    setSelectedTherapist((prevTherapists) => {
      if (therapist.id === 0) {
        return [therapist];
      } else {
        const updatedTherapists = prevTherapists.some(t => t.id === 0) ? [] : prevTherapists;
        if (updatedTherapists.some(t => t.id === therapist.id)) {
          return updatedTherapists.filter(t => t.id !== therapist.id);
        } else if (!duo) {
          return [therapist];
        } else {
          if (updatedTherapists.length >= 2) {
            return updatedTherapists;
          }
          return [...updatedTherapists, therapist];
        }
      }
    });
  }
  // useEffect(() => {
  //   if (therapists.length > 0 && !hasAutoSelected) {
  //     setSelectedTherapist([{ id: 0 }]);
  //     setHasAutoSelected(true);
  //   }
  // }, [therapists, hasAutoSelected]);

  // useEffect(() => {
  //   const saved = sessionStorage.getItem('state');
  //   if (!saved) return;

  //   const parsedState = JSON.parse(saved);
  //   setState(parsedState);

  //   if (parsedState.selectedDate) {
  //     setSelectedDate(new Date(parsedState.selectedDate));
  //   }

  //   if (parsedState.selectedTime) {
  //     setSelectedTime(parsedState.selectedTime);
  //   }

  //   if (Array.isArray(parsedState.selectedTherapist)) {
  //     setSelectedTherapist(parsedState.selectedTherapist);
  //   } else {
  //     setSelectedTherapist([]);
  //   }

  //   if (Array.isArray(parsedState.selectedServices)) {
  //     const productIds = parsedState.selectedServices.map(s => s?.product?.id).filter(Boolean);
  //     setSelectedProductIds(productIds);
  //   }
  // }, []);


  // useEffect(() => {
  //   if (!selectedServices || selectedServices.length === 0) {
  //     navigate('/choose-service');
  //   }
  // }, [selectedServices, navigate]);

  // useEffect(() => {
  //   fetchUnavailableDates();
  // }, [selectedDate, visibleDays]);


  // useEffect(() => {
  //   const now = new Date();
  //   let timeToUse = selectedTime;
  //   if (!selectedTime) {
  //     const nextQuarterHour = Math.ceil(now.getMinutes() / 15) * 15;
  //     now.setMinutes(nextQuarterHour);
  //     now.setSeconds(0);
  //     timeToUse = now.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  //   }
  //   if (selectedDate && selectedTime) {
  //     console.log('fetchTherapist', formatISODate(selectedDate), timeToUse, totalDuration, latitude, longitude, zip_code);
  //     fetchTherapist(formatISODate(selectedDate), timeToUse, totalDuration, latitude, longitude, zip_code);
  //   }
  // else {
  //   handleIfInvalidOrPastDate((selectedDate), timeToUse)
  // }
  //   // fetchUnavailableDates();
  //   fetchBufferTime();
  //   fetchAvailableHours();
  //   updateDaysToShow(selectedDate || new Date());
  // }, [selectedDate, totalDuration, longitude, latitude, zip_code, selectedProductIds, visibleDays]);

  const fetchUnavailableDates = useCallback(async () => {
    try {
      const currentWindow = (daysToShowRef.current && daysToShowRef.current.length) ? daysToShowRef.current : ((selectedDate || selectedDateScroll) ? [selectedDate || selectedDateScroll] : []);
      const startObj = currentWindow.length ? currentWindow[0] : null;
      if (!startObj) return;
      const startDate = new Date(startObj);
      startDate.setHours(0, 0, 0, 0);
      const endObj = currentWindow.length ? currentWindow[currentWindow.length - 1] : new Date(startDate);
      const endDate = new Date(endObj);
      endDate.setDate(endDate.getDate() + 1);

      const formattedStart = startDate.toLocaleDateString('en-CA');
      const formattedEndDate = endDate.toLocaleDateString('en-CA');

      let dates = [];
      if ((selectedDate || selectedTime) && !modalIsOpen2) {
        setPreviousSelection({ date: selectedDate, time: selectedTime });
      }
      if (currentTherapist && modalIsOpen2) {
        if (firstOpen2) {
          setSelectedDate(null);
          setSelectedTime(null);
          setIsFirstOpen2(false);
        }
        dates = await fetchCalendarData(formattedStart, formattedEndDate, currentTherapist);
      } else {
        dates = await fetchCalendarData(formattedStart, formattedEndDate);
      }
      const formattedDates = dates.map(date => new Date(date.split('T')[0]).toDateString());
      setUnavailableDates(formattedDates);
    } catch (error) {
      console.error('Error fetching unavailable dates:', error);
      setUnavailableDates([]);
    }
  }, [selectedDate, fetchCalendarData, selectedDateScroll, currentTherapist, selectedTime, modalIsOpen2, firstOpen2]);
  const fetchAllFlypros = useCallback(async () => {
    if (flyprosFetchedRef.current && allFlypros.length > 0) {
      return allFlypros;
    }

    if (flyprosPromiseRef.current) {
      return flyprosPromiseRef.current;
    }

    setIsLoadingFlypros(true);

    flyprosPromiseRef.current = (async () => {
      try {
        const raw = await UserService.indexByRole(
          { ...filters, status: "ACTIVE" },
          "ROLE_FLYPRO",
          axiosPrivate,
          true
        );

        const sorted = (raw || []).sort((a, b) => {
          return (a.agent_type === "EMPLOYEE" ? -1 : 1) -
                (b.agent_type === "EMPLOYEE" ? -1 : 1);
        });

        setAllFlypros(sorted);
        flyprosFetchedRef.current = true;

        return sorted;
      } catch (error) {
        console.error("Error fetching flypros:", error);
        setAllFlypros([]);
        flyprosFetchedRef.current = false;
        return [];
      } finally {
        setIsLoadingFlypros(false);
        flyprosPromiseRef.current = null;
      }
    })();

    return flyprosPromiseRef.current;
  }, [axiosPrivate, filters, allFlypros]);

  useEffect(() => {
  if (!hydrated) return;

    fetchAllFlypros();
  }, [hydrated, fetchAllFlypros]);

  const handleIfInvalidOrPastDate = async (date, time) => {
    const selectedCategoryIds = selectedServices.map(service => service.category?.id).filter(Boolean);
    const today = new Date();
    const selected = new Date(date);

    const noRealDate =
      !date ||
      date === '1970-01-01' ||
      isNaN(selected.getTime()) ||
      selected < new Date(today.toDateString());

    if (noRealDate || !time) {
      // Afficher uniquement les autres thérapeutes
      const startFrom = new Date(today.toDateString());
      // setHours(getNextHourSlots(startFrom));

      const allTherapists = allFlypros.length ? allFlypros : await fetchAllFlypros();
      const therapistsInZone = zip_code
        ? allTherapists.filter(therapist =>
          therapist.zones?.some(zone => {
            const zipParts = zone.zip_code.split(",");
            return zipParts.some(part => {
              const zipRange = part.split("-").map(Number);
              if (zipRange.length === 1) {
                return zip_code == zipRange[0];
              } else {
                const [startZip, endZip] = zipRange;
                return zip_code >= startZip && zip_code <= endZip;
              }
            });
          })
        )
        : allTherapists;
      const filteredTherapists = therapistsInZone.filter(therapist =>
        therapist.categories?.some(cat => selectedCategoryIds.includes(cat.id))
      );
      //  console.log(selectedCategoryIds, "all", filteredTherapists);
      setTherapist(filteredTherapists);
      setTherapistOther([]);
      // console.log("Date invalide ou dépassée – thérapeutes autres :", allTherapists);

      return true; // pour indiquer que la date était invalide
    }


    return false; // la date est valide
  };




  const fetchBufferTime = useCallback(async () => {
    try {
      const bufferTime = await GeneralSettingService.index('setting=in:buffer_before,buffer_after', axiosPrivate, auth?.accessToken ? false : true);

      const bufferBefore = bufferTime.find(item => item.setting === 'buffer_before')?.value || '0';
      const bufferAfter = bufferTime.find(item => item.setting === 'buffer_after')?.value || '0';

      setBufferTime({ bufferBefore, bufferAfter });
      // console.log('Buffer:', buffertime);
    } catch (error) {
      console.error('Error fetching buffer time:', error);
    }
  }, [axiosPrivate, auth?.accessToken]);
  // const fetchAvailableHours = async () => {
  //   if (selectedDate) {
  //     try {
  //       const responseSelectedDate = await CalendarManagementService.index(
  //         {
  //           date: new Date(selectedDate).toLocaleDateString('en-CA').split('T')[0],
  //           with: 'therapist.media,therapist.zones,calendars_managements_slots.slot',
  //         },
  //         axiosPrivate,
  //         auth?.accessToken ? false : true
  //       );

  //       const filteredSlots = [];
  //       responseSelectedDate.forEach((entry) => {
  //         if (entry.calendars_managements_slots) {
  //           entry.calendars_managements_slots.forEach((slot) => {
  //             if (slot.status === 'AVAILABLE' || slot.status === 'OVER_TIME') {
  //               filteredSlots.push({
  //                 start_time: slot.slot.start_time,
  //                 end_time: slot.slot.end_time,
  //               });
  //             }
  //           });
  //         }
  //       });

  //       // console.log('filteredSlots:', filteredSlots);
  //       // setAvailableHours(filteredSlots);
  //       filteredSlots.sort((a, b) => a.start_time.localeCompare(b.start_time));

  //       const mergedSlots = [];
  //       filteredSlots.forEach((slot) => {
  //         if (
  //           mergedSlots.length > 0 &&
  //           mergedSlots[mergedSlots.length - 1].end_time === slot.start_time
  //         ) {
  //           mergedSlots[mergedSlots.length - 1].end_time = slot.end_time;
  //           mergedSlots[mergedSlots.length - 1].status = slot.status;
  //         } else {
  //           mergedSlots.push({ ...slot });
  //         }
  //       });

  //       // console.log('mergedSlots1:', mergedSlots);
  //       setAvailableHours(mergedSlots);
  //     } catch (error) {
  //       console.error('Error fetching available hours:', error);
  //     }
  //   }
  // };
  const fetchAvailableHours = useCallback(async () => {
    if (!selectedProductIds.length || !zip_code || !latitude || !longitude || !selectedDate) {
      return;
    }

    setIsLoadingAvailability(true);
    try {
      const isEditMode = sessionStorage.getItem("editBookingMode") === "true";
      const booking = JSON.parse(sessionStorage.getItem("newBooking") || '{}');
      const oldBooking = JSON.parse(sessionStorage.getItem("oldBooking") || '{}');
      
      const params = {
        date: (selectedDate || new Date()).toLocaleDateString('en-CA'),
        duration: totalDuration || 0,
        lng: longitude,
        lat: latitude,
        zip_code,
        products: selectedProductIds,
        is_hotel: true,
        hotel_id: auth.user?.hotel?.[0]?.id,
        room_type: room,
        is_duo: duo,
      };

      if (isEditMode) {
        params.booking_id = booking?.id ?? oldBooking?.id ?? 0;
      }

      if (currentTherapist?.id && modalIsOpen2) {
        params.therapists = [currentTherapist.id];
        params.is_duo = false;
      }

      const availabilities = await AvailableSlotsService.store(
        params,
        axiosPrivate,
      );
      setAvailableHours(availabilities || {});
    } catch (error) {
      console.error('Error fetching available hours:', error);
      setAvailableHours({});
    } finally {
      setIsLoadingAvailability(false);
    }
  }, [selectedDate, selectedProductIds, zip_code, latitude, longitude, totalDuration, room, duo, auth.user, axiosPrivate, currentTherapist, modalIsOpen2]);
  const fetchTherapist = useCallback(async (date, time, totalDuration, longitude, latitude, zip_code, filtredData) => {
    const isEditMode = sessionStorage.getItem("editBookingMode") === "true";
        const booking = JSON.parse(sessionStorage.getItem("newBooking"));
        const oldBooking = JSON.parse(sessionStorage.getItem("oldBooking"));
    if (selectedProductIds.length) {
      setIsLoadingTherapists(true);
      try {
        const requestPayload = {
          date,
          time,
          duration: totalDuration,
          lng: longitude,
          lat: latitude,
          zip_code,
          products: selectedProductIds,
          is_duo: duo,
          room_type: room,
          is_hotel: true,
          hotel_id: auth.user?.hotel?.[0]?.id,
          with: `media,categories`,
          ...formData
        };

        if (isEditMode) {
          requestPayload.booking_id = booking?.id ?? oldBooking?.id ?? 0;
        }

        let therapistResponse = await TherapistService.store(requestPayload, axiosPrivate);

        const allTherapists = allFlypros.length
          ? allFlypros
          : await fetchAllFlypros();

        if (duo) {
          const flattened = [].concat(...Object.values(therapistResponse));
          const uniqueById = Array.from(
            new Map(flattened.map(t => [t.id, t])).values()
          );
          therapistResponse = uniqueById;
        }
        if (therapistResponse.length === 0) {
          // const selectedCategoryIds = selectedServices.map(service => service.category?.id).filter(Boolean);

          // const therapistsInZone = zip_code
          // ? allTherapists.filter(therapist =>
          //   therapist.zones?.some(zone => {
          //     const zipParts = zone.zip_code.split(",");
          //     return zipParts.some(part => {
          //       const zipRange = part.split("-").map(Number);
          //       if (zipRange.length === 1) {
          //         return zip_code == zipRange[0];
          //       } else {
          //         const [startZip, endZip] = zipRange;
          //         return zip_code >= startZip && zip_code <= endZip;
          //       }
          //     });
          //   })
          // )
          // : allTherapists;
          // const filteredTherapists = therapistsInZone.filter(therapist =>
          //   therapist.categories?.some(cat => selectedCategoryIds.includes(cat.id))
          // );
          setTherapist([]);
        } else {
          setTherapist(therapistResponse);
        }
        if (
          Array.isArray(state.selectedTherapist) &&
          state.selectedTherapist.length > 0 &&
          Array.isArray(therapistResponse) &&
          therapistResponse.length > 0
        ) {
          const reselected = state.selectedTherapist
            .map(sel => therapistResponse.find(t => t.id === sel.id))
            .filter(Boolean);
          if (reselected.length) {
            setSelectedTherapist(reselected);
          }
        }

        // Récupérer les IDs des thérapeutes déjà sélectionnés
        const therapistIds = new Set(therapistResponse.map(t => t.id));

        // Filtrage basé sur le zip_code uniquement si nécessaire
        const filteredTherapists = zip_code
          ? allTherapists.filter(therapist =>
            !therapistIds.has(therapist.id) &&
            therapist.zones?.some(zone => {
              const [startZip, endZip] = zone.zip_code.split("-").map(Number);
              return zip_code >= startZip && zip_code <= endZip;
            })
          )
          : allTherapists;

        setTherapistOther(filteredTherapists);

      } catch (error) {
        try {
          const allTherapists = allFlypros.length
            ? allFlypros
            : await fetchAllFlypros();
          setTherapist(allTherapists || []);
        } catch (fallbackError) {
          setTherapist([]);
        }
      } finally {
        setIsLoadingTherapists(false);
      }
    }
  }, [selectedProductIds, duo, room, auth.user, filters, formData, axiosPrivate, notify, state.selectedTherapist, zip_code]);

  const fetchTherapistWithRatings = async (therapistId) => {
    const res = await UserService.indexByRole(
      {
        id: therapistId,
        with: 'media,categories,ratings,ratings.creator.media',
      },
      'ROLE_FLYPRO',
      axiosPrivate,
      true
    );

    return Array.isArray(res) ? res[0] : res;
  };

  const openModal = () => setIsOpen(true);
  const openModal2 = async (therapist) => {
    setCurrentTherapist(therapist)
    setIsOpen2(true)
    setIsFirstOpen2(true)
    try {
      const full = await fetchTherapistWithRatings(therapist.id);
      if (full) setCurrentTherapist(full);
    } catch (e) {
      console.error("Failed to load therapist ratings:", e);
    }
  };

  const closeModal = () => setIsOpen(false);
  const closeModal2 = () => {
    setIsOpen2(false);
    setSelectedTherapist([{ id: 0 }]);

    if (previousSelection.date) {
      setSelectedDate(previousSelection.date);
    }
    if (previousSelection.time) {
      setSelectedTime(previousSelection.time);
    }
  };

  const handleSubmit = async (event) => {
    event?.preventDefault();
    setBookingIdempotencyKey(createBookingIdempotencyKey());
    setBookingSuccess(true);
    setDiscountedPrice(totalPrice);
    setPromotions([]);
    setAlertMessage('');
    setPromoCode(null)
  }
  const handleSubmitPopUp = async (event) => {
    event?.preventDefault();
    if (isBookingSubmitting) {
      return;
    }

    if (selectedDate && selectedTime && modalIsOpen2 && currentTherapist) {
      setSelectedTherapist([currentTherapist]);
    }

    // Check if data is still loading
    if (isLoadingAvailability || isLoadingTherapists) {
      notify.warn('Veuillez attendre que les données soient chargées');
      return;
    }

    // Validate that we have basic requirements
    if (!selectedServices || selectedServices.length === 0) {
      notify.error('Veuillez d\'abord sélectionner des services');
      navigate('/choose-products');
      return;
    }

    if (!selectedDate || isNaN(selectedDate.getTime())) {
      notify.error('Veuillez sélectionner une date valide');
      return;
    }

    if (!selectedTime) {
      notify.error('Veuillez sélectionner une heure');
      return;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const selectedDateOnly = new Date(selectedDate);
    selectedDateOnly.setHours(0, 0, 0, 0);

    if (selectedDateOnly < today) {
      notify.error('La date sélectionnée ne peut pas être antérieure à aujourd\'hui');
      return;
    }

    // Validate that available hours are loaded and the selected time is available
    if (Object.keys(availableHours).length === 0) {
      notify.error('Les créneaux horaires ne sont pas encore chargés. Veuillez patienter');
      return;
    }

    if (!availableHours[selectedTime]) {
      notify.error('L\'heure sélectionnée n\'est pas disponible');
      return;
    }

    if (sessionStorage.getItem('editBookingMode') === 'true') {
      setNewBookingPreview({
        date: selectedDate,
        time: selectedTime,
        therapists: selectedTherapist, // array
        products: selectedServices.map(s => s.product), // array
      });
      setComparisonModalOpen(true);
      return; // Do NOT proceed with creation logic
    }

    const selectedTherapists = selectedTherapist[0]?.id === 0
      ? (duo && therapists.length >= 2 ? [therapists[0], therapists[1]]
        : !duo && therapists.length >= 1 ? [therapists[0]] : [{ id: 0 }])
      : selectedTherapist;

    if (duo && selectedTherapists.length !== 2) {
      notify.warn('Veuillez sélectionner deux thérapeutes pour un duo.');
      return;
    } else if (!duo && selectedTherapists.length !== 1) {
      notify.warn('Veuillez sélectionner un thérapeute.');
      return;
    }
    const noPreferences = selectedTherapist.length === 1 && selectedTherapist[0].id === 0;

    const hotel = auth.user?.hotel?.[0];
    const hotelAddress = hotel?.address || {};

    // Format date and time properly for backend
    const formattedDate = selectedDate.toLocaleDateString('en-CA'); // YYYY-MM-DD format
    const combinedDateTime = `${formattedDate} ${selectedTime}`;

    const finalSubtotal = promotions?.id ? discountedPrice : selectedServices
      .map(service => service.product.price)
      .reduce((acc, price) => acc + price, 0);
    
    const durations = selectedServices?.map(s => parseInt(s?.product?.duration || 0, 10)) || [];

    const maxDuration = (duo && durations.length === 2)
    ? Math.max(...durations)
    : (duo && durations.length === 4)
      ? Math.max(durations[0], durations[1]) + Math.max(durations[2], durations[3])
      : durations.reduce((total, duration) => total + duration, 0);


    const currentBookingIdempotencyKey = bookingIdempotencyKey || createBookingIdempotencyKey();
    if (!bookingIdempotencyKey) {
      setBookingIdempotencyKey(currentBookingIdempotencyKey);
    }

    const payload = {
      ...formData,
      address_id: hotel?.address_id,
      street: hotelAddress?.street || '',
      city: hotelAddress?.city || '',
      zip_code: hotelAddress?.zip_code || '',
      state: hotelAddress?.state || '',
      latitude: hotelAddress?.latitude || null,
      longitude: hotelAddress?.longitude || null,
      product_id: selectedServices[0].products[0].id,
      products: selectedServices.map(product => product.product.id),
      country: "Switzerland",
      country_code: "CH",
      date: combinedDateTime,
      start_before: combinedDateTime,
      hotel_id: hotel?.id,
      client_id: auth.user?.id,
      no_preferences: noPreferences,
      duo: duo,
      room_type: room,
      duration: maxDuration,
      status: 'CREATED',
      subtotal: finalSubtotal,
      promocode: promotions?.id && discountedPrice != totalPrice ? promoCode : "",
      locale: i18n.language,
      message: description,
      therapists: selectedTherapists.map(t => t.id),
      device_type: `${navigator.userAgentData?.platform} - ${navigator.userAgentData?.brands?.[1]?.brand}`,
      device_version: navigator.userAgentData?.brands?.[1]?.version,
      offline_payment: true,
      idempotency_key: currentBookingIdempotencyKey
    };
    try {
      setIsBookingSubmitting(true);
      const response = await BookingService.store(payload, axiosPrivate);
      if (promotions?.id && discountedPrice != totalPrice) {
        const promoUsageData = {
          is_used: true,
          value: discountedPrice,
          promotion_id: promotions.id,
          client_id: auth.user.id,
          booking_id: response.data?.id,
        };

        await PromotionUsageService.store(promoUsageData, axiosPrivate);
      }
      if (response.data) {
        sessionStorage.removeItem('state')
        // setBookingSuccess(true);
      }
      setBookingIdempotencyKey(null);
      navigate('/tasks')
    } catch (error) {
      console.error("Booking submission error:", error);
      notify.error('La réservation n’a pas été confirmée à l’écran. Vérifiez la liste des commandes avant de réessayer.');
    } finally {
      setIsBookingSubmitting(false);
    }
  };

  const handlePreviewModification = (e) => {
    e.preventDefault();

    // Grab current selection (date, time, therapist, product, etc.)
    setNewBookingPreview({
      date: selectedDate,
      time: selectedTime,
      therapists: selectedTherapist, // array
      products: selectedServices.map(s => s.product), // array
    });

    setComparisonModalOpen(true);
  }

  const handleAcknowledgeUpdate = async () => {
    // Optionally, you could show a loading spinner here

    try {
      // Build your payload from the *latest* state:
      const selectedTherapists = selectedTherapist[0]?.id === 0
        ? (duo && therapists.length >= 2 ? [therapists[0], therapists[1]]
          : !duo && therapists.length >= 1 ? [therapists[0]] : [{ id: 0 }])
        : selectedTherapist;

      if (duo && selectedTherapists.length !== 2) {
        notify.warn('Veuillez sélectionner deux thérapeutes pour un duo.');
        return;
      } else if (!duo && selectedTherapists.length !== 1) {
        notify.warn('Veuillez sélectionner un thérapeute.');
        return;
      }

      const hotel = auth.user?.hotel?.[0];
      const hotelAddress = hotel?.address || {};
      const time = formatTimeTo24Hour(selectedTime);
      const combinedDateTime = `${selectedDate.toLocaleDateString('en-CA')} ${selectedTime}`;

      const payload = {
        ...formData,
        address_id: hotel?.address_id,
        street: hotelAddress?.street || '',
        city: hotelAddress?.city || '',
        zip_code: hotelAddress?.zip_code || '',
        state: hotelAddress?.state || '',
        latitude: hotelAddress?.latitude || null,
        longitude: hotelAddress?.longitude || null,
        product_id:
          selectedServices && selectedServices.length > 0 && selectedServices[0].product
            ? selectedServices[0].product.id
            : null,
        products: Array.isArray(selectedServices)
          ? selectedServices
            .map(service =>
              service.product && service.product.id ? service.product.id : null
            )
            .filter(Boolean)
          : [],
        country: "Switzerland",
        country_code: "CH",
        date: combinedDateTime,
        start_before: combinedDateTime,
        hotel_id: hotel?.id,
        client_id: auth.user?.id,
        no_preferences: selectedTherapist.length === 1 && selectedTherapist[0].id === 0,
        duo: duo,
        duration: totalDuration,
        status: 'UPDATED',
        locale: i18n.language,
        message: description,
        therapists: selectedTherapists.map(t => t.id),
        device_type: `${navigator.userAgentData?.platform} - ${navigator.userAgentData?.brands?.[1]?.brand}`,
        device_version: navigator.userAgentData?.brands?.[1]?.version
      };

      // The booking ID is from state/session (your edit flow should provide it)
      const bookingId = oldBooking.id || newBooking.id;

      const responseUpdate = await BookingService.update(bookingId, payload, axiosPrivate);

      // Clean up edit-related session keys
      // sessionStorage.removeItem('editBookingMode');
      // sessionStorage.removeItem('oldBooking');
      // sessionStorage.removeItem('bookingToEdit');
      // sessionStorage.removeItem('modificationBookingId');
      // sessionStorage.removeItem('newBooking');
      // sessionStorage.removeItem('state');
      if (responseUpdate.data) {
        sessionStorage.clear();
        // setBookingSuccess(true);
        navigate('/tasks');
      } else {
        setBypassPrompt(false);
      }
    } catch (error) {
      console.error('Update booking error:', error, error?.response?.data);
      notify.error("Erreur lors de la mise à jour de la réservation !");
    }
  };

  const handleSubmitFilter = (event) => {
    event.preventDefault();
    setFilter(formData);
    setTimeout(async () => {
      handleHourClick(selectedTime);
      if (selectedDate && selectedTime) {
        await fetchTherapist(
          formatISODate(selectedDate),
          selectedTime,
          totalDuration,
          longitude,
          latitude,
          zip_code
        );
      }
    }, 1000);

    closeModal();
  };


  const handleMonthChange = (direction) => {
    const now = Date.now();
    if (window.lastMonthChange && (now - window.lastMonthChange) < 300) return;
    window.lastMonthChange = now;


  const currentDate = selectedDateScroll || selectedDate;
    if (!currentDate || isNaN(currentDate.getTime())) {
      console.error('Invalid date in handleMonthChange');
      return;
    }

    const maxVisibleMonths = 2;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const firstAllowedMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastAllowedMonth = new Date(today.getFullYear(), today.getMonth() + maxVisibleMonths, 1);
  const newDate = new Date(currentDate);
    newDate.setDate(1);
    newDate.setMonth(newDate.getMonth() + direction);
    newDate.setHours(0, 0, 0, 0);
    if (newDate < firstAllowedMonth) return;
    if (newDate > lastAllowedMonth) return;
    if (newDate.getFullYear() === today.getFullYear() && newDate.getMonth() === today.getMonth()) {
      newDate.setDate(today.getDate());
    } else {
      newDate.setDate(1);
    }
    const lastAllowedDate = new Date(today.getFullYear(), today.getMonth() + maxVisibleMonths + 1, 0);
    if (newDate > lastAllowedDate) newDate.setTime(lastAllowedDate.getTime());
    setSelectedDateScroll(newDate);
    setSelectedDate(null);
    setSelectedTime(null);
    setTherapist('');
    updateDaysToShow(newDate);
    setSelectedTherapist([{ id: 0 }]);
    try {
      fetchUnavailableDates();
    } catch (e) {
    }

  };

  const handleDayChange = (direction) => {
    const now = Date.now();
    if (window.lastDayChange && (now - window.lastDayChange) < 200) return;
    window.lastDayChange = now;

    const currentDate = (daysToShowRef.current && daysToShowRef.current.length)
      ? daysToShowRef.current[0]
      : (selectedDateScroll || selectedDate);
    if (!currentDate || isNaN(currentDate.getTime())) {
      console.error('Invalid date in handleDayChange');
      return;
    }

    const container = document.querySelector('.row-date');
    if (!container) return;

    const dayWidth = container.querySelector('.btn-day')?.offsetWidth || 0;
    const containerWidth = container.clientWidth;
    const visibleItems = Math.floor(containerWidth / dayWidth) || 1;
    const daysToScroll = Math.max(1, Math.floor(visibleItems - 0.5));
    const maxVisibleMonths = 2;
    const windowSize = 9;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const endExclusive = new Date(today.getFullYear(), today.getMonth() + maxVisibleMonths + 1, 1);
    const allDays = [];
    let cur = new Date(today);
    while (cur < endExclusive) {
      allDays.push(new Date(cur.getFullYear(), cur.getMonth(), cur.getDate()));
      cur.setDate(cur.getDate() + 1);
    }
    const firstVisible = (daysToShowRef.current && daysToShowRef.current.length)
      ? daysToShowRef.current[0]
      : (daysToShow && daysToShow.length ? daysToShow[0] : (selectedDateScroll || selectedDate || today));
    let currentStartIndex = allDays.findIndex(d => d.getTime() === new Date(firstVisible.getFullYear(), firstVisible.getMonth(), firstVisible.getDate()).getTime());
    if (currentStartIndex === -1) currentStartIndex = Math.max(0, allDays.length - windowSize);

    const maxStart = Math.max(0, allDays.length - windowSize);
    let newStart = currentStartIndex + direction * daysToScroll;
    if (newStart < 0) newStart = 0;
    if (newStart > maxStart) newStart = maxStart;

  const newWindow = allDays.slice(newStart, newStart + windowSize);
  setDaysToShow(newWindow);
  daysToShowRef.current = newWindow;
    const newSelected = newWindow.length ? newWindow[0] : (allDays[allDays.length - 1] || today);
    setSelectedDate(newSelected);
    setSelectedDateScroll(newSelected);
    setSelectedTime(null);
    setTherapist('');
    setSelectedTherapist([{ id: 0 }]);
    updateDaysToShow(newSelected);
    try {
      fetchUnavailableDates();
    } catch (e) {
    }
  };
  const redirectToPartnerHotels = () => {
    window.location.href = '/hotels';
  };

  function handleDayClick(date) {
    // Validate date parameter
    if (!date || isNaN(date.getTime())) {
      console.error('Invalid date in handleDayClick');
      return;
    }

    // Prevent selecting past dates
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (date < today) {
      return; // Don't allow selecting past dates
    }

    setSelectedDate(date);
    setSelectedTime(null);
    setTherapist('');
    setSelectedTherapist([{ id: 0 }]);


    const isSunday = date.getDay() === 0;
    const isHotel = !!auth.user?.hotel?.[0];

    if (isSunday && !isHotel) {
      setShowPopup(true);
    }
  }

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: type === "checkbox"
        ? prevState[name] === value
          ? "" // Uncheck si déjà sélectionné
          : value
        : value,
    }));
  };

  const handleResetFilter = () => {

    setFormData({
      tags: "",
      is_asca: "",
      is_rme: "",
      civility: "",
    })

  }

  const civilityLabels = {
    MS: "Femme",
    MR: "Homme",
  };

  const tagsLabels = {
    "contains:french": t('french'),
    "contains:english": t('english'),
    "contains:german": t('german'),
    "contains:italian": t('italian'),
    "contains:spanish": t('spanish'),
    "contains:arabic": t('arabic'),
    "contains:portuguese": t('portuguese'),
    "contains:russian": t('russian')
  };

  const getFilterText = () => {
    let filters = [];


    if (formData.civility && civilityLabels[formData.civility]) {
      filters.push(civilityLabels[formData.civility]);
    }


    if (formData.tags && tagsLabels[formData.tags]) {
      filters.push(tagsLabels[formData.tags]);
    }


    if (formData.is_asca === "1") {
      filters.push("ASCA");
    }


    if (formData.is_rme === "1") {
      filters.push("RME");
    }
    return filters.length > 0 ? `Filter: ${filters.join(" - ")}` : "";
  };


  const getMonthName = (date) => {
    if (!date || isNaN(date.getTime())) {
      return new Date().toLocaleString(i18n.language, { month: 'long' }).charAt(0).toUpperCase()
        + new Date().toLocaleString(i18n.language, { month: 'long' }).slice(1);
    }
    const monthName = date.toLocaleString(i18n.language, { month: 'long' });
    return monthName.charAt(0).toUpperCase() + monthName.slice(1);
  };

  const getDayName = (date) => {
    if (!date || isNaN(date.getTime())) {
      return new Date().toLocaleString(i18n.language, { weekday: 'short' });
    }
    return date.toLocaleString(i18n.language, { weekday: 'short' });
  };

  const getNextHourSlots = (date) => {
    const now = new Date();
    const hours = [];

    // Validate date parameter
    if (!date || isNaN(date.getTime())) {
      date = new Date(); // Fallback to current date
    }

    if (date?.toDateString() === now?.toDateString()) {
      const minutes = now.getMinutes();
      const nextQuarterHour = Math.ceil(minutes / 15) * 15;
      now.setMinutes(nextQuarterHour);
      now.setSeconds(0);

      for (let i = 0; i < 57; i++) {
        const slot = new Date(now.getTime() + i * 15 * 60000);
        if (slot.getHours() >= 8 && slot.getHours() < 22) {
          hours.push(slot.toLocaleTimeString('en-CA', { timeZone: 'Europe/Zurich', hour: '2-digit', minute: '2-digit', hour12: false }));
        }
      }
    } else {
      const startOfDay = new Date(date);
      startOfDay.setHours(8, 0, 0, 0);

      for (let i = 0; i < 57; i++) {
        const slot = new Date(startOfDay.getTime() + i * 15 * 60000);
        if (slot.getHours() >= 8 && slot.getHours() < 22) {
          hours.push(slot.toLocaleTimeString('en-CA', { hour: '2-digit', minute: '2-digit', hour12: false }));
        }
      }
    }

    return hours;
  };

  const scrollLeft = () => {
    const container = document.querySelector('.row-day');
    if (!container) return;

    const dayWidth = container.querySelector('.btn-hour')?.offsetWidth || 0;
    const visibleItems = Math.floor(container.clientWidth / dayWidth);
    const scrollDistance = dayWidth * (visibleItems - 0.5);

    container.scrollBy({ left: -scrollDistance, behavior: 'smooth' });
  };

  const scrollRight = () => {
    const container = document.querySelector('.row-day');
    if (!container) return;

    const dayWidth = container.querySelector('.btn-hour')?.offsetWidth || 0;
    const visibleItems = Math.floor(container.clientWidth / dayWidth);
    const scrollDistance = dayWidth * (visibleItems - 0.5);

    container.scrollBy({ left: scrollDistance, behavior: 'smooth' });
  };

  const getInitialDaysToShow = () => {
    const maxVisibleMonths = 2;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const endExclusive = new Date(today.getFullYear(), today.getMonth() + maxVisibleMonths + 1, 1);
    const days = [];
    let cur = new Date(today);
    while (cur < endExclusive) {
      days.push(new Date(cur.getFullYear(), cur.getMonth(), cur.getDate()));
      cur.setDate(cur.getDate() + 1);
    }
    const windowSize = 9;
    const anchor = (selectedDate || selectedDateScroll) ? new Date(selectedDate || selectedDateScroll) : new Date(today);
    anchor.setHours(0, 0, 0, 0);
    let startIndex = days.findIndex(d => d.getTime() >= anchor.getTime());
    if (startIndex === -1) startIndex = Math.max(0, days.length - windowSize);
    const maxStart = Math.max(0, days.length - windowSize);
    const clampedStart = Math.min(startIndex, maxStart);
    return days.slice(clampedStart, clampedStart + windowSize);
  };

  const [showPopup, setShowPopup] = useState(false);

  const updateDaysToShow = (baseDate) => {
    if (!baseDate || isNaN(baseDate.getTime())) {
      console.error('Invalid baseDate in updateDaysToShow');
      return;
    }

    const maxVisibleMonths = 2;
    const windowSize = 9;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const startAllowed = new Date(today);
    const endExclusive = new Date(today.getFullYear(), today.getMonth() + maxVisibleMonths + 1, 1);
    const allDays = [];
    let cur = new Date(startAllowed);
    while (cur < endExclusive) {
      allDays.push(new Date(cur.getFullYear(), cur.getMonth(), cur.getDate()));
      cur.setDate(cur.getDate() + 1);
    }

    const lastAllowedDate = allDays[allDays.length - 1];
    const anchor = new Date(baseDate);
    anchor.setHours(0, 0, 0, 0);
    if (anchor < allDays[0]) anchor.setTime(allDays[0].getTime());
    if (anchor > lastAllowedDate) anchor.setTime(lastAllowedDate.getTime());
    let startIndex = allDays.findIndex(d => d.getTime() >= anchor.getTime());
    if (startIndex === -1) startIndex = Math.max(0, allDays.length - windowSize);

    const maxStart = Math.max(0, allDays.length - windowSize);
    const clampedStart = Math.min(startIndex, maxStart);
    const slice = allDays.slice(clampedStart, clampedStart + windowSize);
    setDaysToShow(slice);

    daysToShowRef.current = slice;
  };

  const hours = getNextHourSlots(selectedDate);

  const handleHourClick = useCallback((hour) => {
    let dateToUse = selectedDate;

    if (!selectedDate || isNaN(selectedDate.getTime())) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      dateToUse = today;
      setSelectedDate(dateToUse);
    }

    // Validate that the date is not in the past
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (dateToUse < today) {
      console.warn('Cannot select time for past date');
      return;
    }

    setSelectedTime(hour);
    if (selectedDate && modalIsOpen2 && currentTherapist) {
      setSelectedTherapist([currentTherapist]);
    } else {
      setSelectedTherapist([{ id: 0 }]);
    }

    if (longitude && latitude && zip_code && totalDuration > 0) {
      // fetchTherapist(
      //   formatISODate(dateToUse),
      //   hour,
      //   totalDuration,
      //   longitude,
      //   latitude,
      //   zip_code
      // );
    }
  }, [selectedDate, setSelectedDate, setSelectedTime, longitude, latitude, zip_code, totalDuration, fetchTherapist]);

  // Removed automatic time selection - user must manually select time
  // useEffect(() => {
  //   if (!selectedTime && availableHours && Object.keys(availableHours).length > 0) {
  //     const firstAvailableHour = Object.entries(availableHours).find(([hour, available]) => available)?.[0];
  //     if (firstAvailableHour) {
  //       handleHourClick(firstAvailableHour);
  //     }
  //   }
  // }, [availableHours, handleHourClick, selectedTime]);

  useEffect(() => {
    const handleSundayPopup = () => {
      setShowPopup(true);
    };

    window.addEventListener('showSundayPopup', handleSundayPopup);
    return () => {
      window.removeEventListener('showSundayPopup', handleSundayPopup);
    };
  }, []);
  // sessionStorage.removeItem("previousPath");

  const fetchPromotions = async () => {
    try {
      const today = new Date().toISOString().split("T")[0];
      const response = await PromotionService.index(
        {
          code: promoCode,
          date_validity: `gte:${today}`,
          is_active: 1,
          with: 'usage',
          is_gift: 1,
        },
        axiosPrivate
      );
      console.log({ response })
      if (response?.length > 0) {
        return response[0];
      } else {
        setAlertMessage(t("promo.invalid"));
      }
    } catch (error) {
      console.error("Error fetching promotion", error);
    }
  };

  const handlePromoCodeSubmit = async () => {

    const promotions = await fetchPromotions();
    setDiscountedPrice(totalPrice);
    setPromotions(promotions);

    const promo = promotions?.code === promoCode;
    console.log("promo:", promo);

    if (promo) {
      const currentDate = new Date();
      const validityDate = new Date(promotions.date_validity);

      if (currentDate <= validityDate) {
        let newPrice = totalPrice;
        let remainingBalance;
        if (promotions.total_usage === -1) {
          console.log("Total usage is unlimited.");
        }

        if (Array.isArray(promotions.usage) && promotions.usage.length >= 0) {
          const usedPromotions = promotions.usage.filter(usage => usage.is_used);

          if (promotions.total_usage !== -1 && usedPromotions.length >= promotions.total_usage) {
            setAlertMessage(t("promo.usage_limit_reached"));
            return;
          }

          const userUsage = promotions.usage.filter(
            usage => usage.is_used && usage.client_id === auth?.user?.id
          );

          if (promotions.usage_per_customer !== -1 && userUsage.length >= promotions.usage_per_customer) {
            setAlertMessage(t("promo.user_limit_exceeded"));
            return;
          }

          if (promotions.type === "FREE_CREDITS") {
            if (promotions.extra['remaining'] === 0) {
              setAlertMessage(t("promo.credit_expired"));
            return;
          }
            const remainingCredits = promotions.usage
              .filter(usage => usage.value > 0);
            if (remainingCredits) {
              promotions.amount = promotions.extra['remaining'];

            }
          }
        }

        let updatedTotalPrice = 0;
        let hasValidProduct = false;
        let durationMismatch = false;
        let remainingUses = promotions.total_usage;

        for (const service of selectedServices) {
          const product = service.product;
          let newProductPrice = product.price;

          const isValidProduct =
            !promotions.product_id ||
            product?.id === promotions.product_id;

          if (isValidProduct) {
            hasValidProduct = true;
            if (promotions.type === "DURATION") {
              if (product.hotel_id) {
                setAlertMessage(t("promo.invalid_hotels"));
                return;
              }

              if (promotions.amount == product?.duration && remainingUses > 0) {
                console.log("is valid duration");
                newProductPrice = 0;
                remainingUses -= 1;
              } else {
                console.log("is noooo valid duration");
                durationMismatch = true;
                setAlertMessage(t("promo.invalid_duration"));
                newProductPrice = product.price;
              }
            } else if (promotions.type === "FREE") {
              newProductPrice = 0;
            } else if (promotions.type === "PERCENT_OFF") {
              newProductPrice = product.price - (product.price * promotions.amount) / 100;
            } else if (promotions.type === "FLATT_OFF" || promotions.type === "FREE_CREDITS") {
              newProductPrice = Math.max(0, product.price - promotions.amount);
            }
          }

          updatedTotalPrice += newProductPrice;
        }

        if (!hasValidProduct) {
          setAlertMessage(t("promo.invalid_services"));
          return;
        }

        console.log("Updated Total Price:", updatedTotalPrice);


        setDiscountedPrice(updatedTotalPrice);

        if (durationMismatch) {
          setAlertMessage(t("promo.invalid_duration"));
          return;
        };

        setAlertMessage(t("promo.applied_successfully"));

        if (remainingBalance >= 0) {
          console.log(`Remaining balance after discount: ${remainingBalance}`);
        }

      } else {
        setAlertMessage(t("promo.expired"));
      }
    }

  };

  const formatSelectedDate = (date) => {
    const options = { day: 'numeric', month: 'short' };
    return new Intl.DateTimeFormat(i18n.language === 'fr' ? 'fr-FR' : 'en-US', options).format(new Date(date));
  };

  const addMinutesToTime = (time, duration) => {
    const [hours, minutes] = time.split(':').map(Number);
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes + duration);
    return date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <>
      <MenuHeader />
      <Nav page="therapist" />
      <div className={`container ${!modalIsOpen2 && 'container-therapeut'}`}>
        {!modalIsOpen2 && <h2 style={{ textAlign: 'center', fontWeight: 700, color: '#000000' }}>{t('choose_therapist_and_date')}</h2>}
      </div>
      <form className="form-masseur" onSubmit={handleSubmit}>
        {modalIsOpen2 ? <>
          <div className="contentModal">

            <HeaderTherapist currentTherapist={currentTherapist} closeModal2={closeModal2} />
            {/* <form className="form-masseur" onSubmit={handleSubmit}> */}
            <DateTimeSelector selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
              selectedTime={selectedTime}
              modalIsOpen2={modalIsOpen2}
              selectedDateScroll={selectedDateScroll}
              setSelectedTime={setSelectedTime}
              handleMonthChange={handleMonthChange}
              handleDayChange={handleDayChange}
              handleDayClick={handleDayClick}
              handleHourClick={handleHourClick}
              daysToShow={daysToShow}
              hours={hours}
              totalPrice={totalPrice}
              scrollLeft={scrollLeft}
              scrollRight={scrollRight}
              openModal={openModal}
              getMonthName={getMonthName}
              getDayName={getDayName}
              getFilterText={getFilterText()}
              handleResetFilter={handleResetFilter}
              unavailableDates={unavailableDates}
              availableHours={availableHours}
              buffertime={buffertime}
              totalDuration={totalDuration}
              isEditMode={false}
              isHotel={!!auth.user?.hotel?.[0]}
              currentTherapist={currentTherapist}
            />

            {/* </form> */}
            <ReviewList currentTherapist={currentTherapist} />
            <Informations currentTherapist={currentTherapist} axios={axiosPrivate} auth={auth} />
          </div></> : <>
          <div className={`container ${!modalIsOpen2 && 'container-therapeut'}`}>
            <DateTimeSelector
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
              selectedDateScroll={selectedDateScroll}
              selectedTime={selectedTime}
              setSelectedTime={setSelectedTime}
              handleMonthChange={handleMonthChange}
              handleDayChange={handleDayChange}
              handleDayClick={handleDayClick}
              handleHourClick={handleHourClick}
              daysToShow={daysToShow}
              hours={hours}
              totalPrice={totalPrice}
              scrollLeft={scrollLeft}
              scrollRight={scrollRight}
              openModal={openModal}
              getMonthName={getMonthName}
              getDayName={getDayName}
              getFilterText={getFilterText()}
              unavailableDates={unavailableDates}
              availableHours={availableHours}
              buffertime={buffertime}
              totalDuration={totalDuration}
              handleResetFilter={handleResetFilter}
              isHotel={!!auth.user?.hotel?.[0]}
            />
            <div className="form-group group-masseur">
             {therapists.length > 0 && selectedDate && selectedTime &&
                <div className="therapist-item" onClick={() => !isLoadingTherapists && addedTherapist({ id: 0 })}
                  style={{ 
                    cursor: isLoadingTherapists ? 'wait' : 'pointer',
                    opacity: isLoadingTherapists ? 0.6 : 1 
                  }}
                >
                  <div className="therapist-info">
                    <p className="name" style={{ marginLeft: '50px', fontWeight: 700 }}>{t('no_preference')}</p>
                    <button
                      type="button"
                      className={`btn-outline-primary default ${selectedTherapist.some(t => t.id === 0) ? 'selected' : ''}`}
                      disabled={isLoadingTherapists}
                    >
                      &gt;
                    </button>
                  </div>
                </div>
              }
              {therapists.length > 0 && therapists?.map((therapist) => (
                <div key={therapist.id} className="therapist-item" onClick={() => !isLoadingTherapists && addedTherapist(therapist)}
                  style={{ 
                    cursor: isLoadingTherapists ? 'wait' : 'pointer',
                    opacity: isLoadingTherapists ? 0.6 : 1 
                  }}
                >
                  <img onClick={(e) => { e.stopPropagation(); openModal2(therapist); }} src={therapist.media?.length ? therapist.media[0].original_url : user} alt={therapist?.name} className="therapist-image" />
                  <div className="therapist-info">
                    <p className="name">{therapist?.firstname}  
                      <Tooltip title={t('more_info')} placement="top" arrow slotProps={tooltipProps}>
                        <IconButton 
                          onClick={(e) => { 
                            if (!isLoadingTherapists) {
                              e.stopPropagation(); 
                              openModal2(therapist); 
                            }
                          }} 
                          disabled={isLoadingTherapists}
                        >
                          <InfoIcon />
                        </IconButton>
                      </Tooltip>
                    </p>
                    <p className="note">{therapist?.extra?.rating}/5</p>
                    <button
                      type="button"
                      className={`btn-outline-primary ${selectedTherapist.some(t => t.id === therapist.id) ? 'selected' : ''}`}
                      disabled={isLoadingTherapists}
                    >
                      &gt;
                    </button>
                  </div>
                </div>
              ))}
              {therapists.length > 0 &&
                <>
                  <div className="form-group" style={{ flex: '100%' }}>
                    <TextField
                      label={t('message_to_therapist')}
                      placeholder={t('write_your_message')}
                      multiline
                      // required
                      rows={4}
                      fullWidth
                      margin="normal"
                      variant="outlined"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                    />
                  </div>
                </>
              }

            </div>
            {/* {therapistsOther.length > 0 && !duo && (
              <>
                <div className='other'>{t('available_other_slots')}</div>
                <div className="form-group group-masseur">

                  {therapistsOther?.map((therapist) => (
                    <div key={therapist.id} className="therapist-item" onClick={() => addedTherapist(therapist)}>
                      <img onClick={() => openModal2(therapist)} src={therapist.media.length ? therapist.media[0].original_url : user} alt={therapist?.name} className="therapist-image" />
                      <div className="therapist-info">
                        <p className="name">{therapist?.firstname} <span className="info-therapist">i</span></p>
                        <p className="note">{therapist?.extra?.rating ? therapist.extra.rating.toFixed(1) : "5"}/5</p>
                        <button
                          type="button"
                          className={`btn-outline-primary ${selectedTherapist.some(t => t.id === therapist.id) ? 'selected' : ''}`}
                        >
                          &gt;
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )} */}
          </div>

        </>}

        <div className='btn-bottom'>

          {!modalIsOpen2 ?
            (
              <button
                type="submit"
                className="btn btn-primary"
                disabled={!selectedTime || isLoadingAvailability || isLoadingTherapists || Object.keys(availableHours).length === 0 || (modalIsOpen2 && duo)}
              >
                {isLoadingAvailability || isLoadingTherapists ? 'Chargement...' : t('next')}
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setIsOpen2((prev) => !prev);
                }}
              >
                {t('close')}
              </button>
            )
          }
        </div>

      </form >
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <p>{t('no_service_sunday')}</p>
            <button onClick={redirectToPartnerHotels} className="btn redirect-button">
              {t('choose_partner_hotel')}
            </button>
            <button onClick={() => setShowPopup(false)} className="btn close-button">
              {t('close')}
            </button>
          </div>
        </div>
      )
      }


      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className="contentModal">
          <div className="headerModal modal-icone">
            <button type="button" onClick={closeModal} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
              <img src={back} alt="Fermer" />
            </button>
            <button type="button" onClick={closeModal} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
              <img src={croix} alt="Fermer" />
            </button>
          </div>
          <div className="form-inscription">
            <form onSubmit={handleSubmitFilter}>

              <div className="form-choix">
                <div className="form-radio">
                  <input
                    type="checkbox"
                    name="civility"
                    value="MR"
                    checked={formData.civility === "MR"}
                    id="monsieur"
                    onChange={handleChange}
                  />
                  <label htmlFor="monsieur">{t('male')}</label>
                </div>
                <div className="form-radio">
                  <input
                    type="checkbox"
                    name="civility"
                    value="MS"
                    id="madame"
                    checked={formData.civility === "MS"}
                    onChange={handleChange}
                  />
                  <label htmlFor="madame">{t('female')}</label>
                </div>
              </div>
              <div className='flex-row gap-10'>
                <div className="form-text">
                  <label>{t('language')}</label>
                  <select defaultValue={formData.tags} name="tags" onChange={handleChange}>
                    <option value="contains:french">{t('french')}</option>
                    <option value="contains:english">{t('english')}</option>
                    <option value="contains:german">{t('german')}</option>
                    <option value="contains:italian">{t('italian')}</option>
                    <option value="contains:spanish">{t('spanish')}</option>
                    <option value="contains:arabic">{t('arabic')}</option>
                    <option value="contains:portuguese">{t('portuguese')}</option>
                    <option value="contains:russian">{t('russian')}</option>
                  </select>
                </div>
              </div>
              <div className="form-choix">
                <div className="form-radio">
                  <input
                    type="checkbox"
                    name="is_asca"
                    value="1"
                    id="is_asca"
                    checked={formData.is_asca === "1"}
                    onChange={handleChange}
                  />
                  <label htmlFor="is_asca">{t('asca')}</label>
                </div>
                <div className="form-radio">
                  <input
                    type="checkbox"
                    name="is_rme"
                    value="1"
                    id="is_rme"
                    checked={formData.is_rme === "1"}
                    onChange={handleChange}
                  />
                  <label htmlFor="is_rme">{t('rme')}</label>
                </div>
              </div>

              <div className="form-button">
                <button className='btn-submit' type="submit">{t('filter')}</button>
              </div>
            </form>
          </div>
        </div>
      </Modal>

      {comparisonModalOpen && newBookingPreview && (
        <Modal
          isOpen={comparisonModalOpen}
          onRequestClose={() => setComparisonModalOpen(false)}
          style={customStyles}
          contentLabel="Comparaison des détails de réservation"
        >
          <div className="contentModal">
            <div className="headerModal modal-icone">
              <button type="button" onClick={() => setComparisonModalOpen(false)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                <img src={back} alt="Fermer" />
              </button>
              <button type="button" onClick={() => setComparisonModalOpen(false)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                <img src={croix} alt="Fermer" />
              </button>
            </div>
            <div className="form-inscription">
              <h3 style={{ textAlign: "center", margin: "0 0 24px 0" }}>
                Comparaison des détails de réservation
              </h3>
              <div className="comparison-grid" style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "32px",
                marginBottom: "32px",
              }}>
                <div>
                  <strong>Avant</strong>
                  <p>Date: {formatDisplayDate(oldBooking.date)}</p>
                  <p>Heure: {oldBooking.time}</p>
                  <p>Thérapeute(s): {(oldBooking.therapists || []).map(t => t.firstname).join(', ')}</p>
                  <p>Produit(s): {(oldBookingTrans.products || []).map(p => p.name).join(', ')}</p>
                </div>
                <div>
                  <strong>Après</strong>
                  <p>Date: {formatDisplayDate(newBookingPreview.date)}</p>
                  <p>Heure: {newBookingPreview.time}</p>
                  <p>Thérapeute(s): {(newBookingPreview.therapists || []).map(t => t.firstname).join(', ')}</p>
                  <p>Produit(s): {(newBookingPreviewTrans.products || []).map(p => p.name).join(', ')}</p>
                </div>
              </div>
              <div className="form-button" style={{ display: "flex", gap: "16px", justifyContent: "center" }}>
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  onClick={() => setComparisonModalOpen(false)}
                >
                  Annuler
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    setComparisonModalOpen(false);
                    setBookingSuccess(false)
                    setBypassPrompt(true);
                    handleAcknowledgeUpdate();
                  }}
                >
                  Confirmer la modification
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}

      {bookingSuccess && (
        <Dialog
          open={bookingSuccess}
          onClose={() => {
            if (!isBookingSubmitting) {
              setBookingSuccess(false);
              setBookingIdempotencyKey(null);
            }
          }}
          aria-labelledby="booking-success-dialog"
          BackdropProps={{
            sx: {
              backgroundColor: 'rgba(0, 0, 0, 0.3)',
              backdropFilter: 'blur(4px)',
            }
          }}
          PaperProps={{
            style: {
              borderRadius: '12px',
              padding: '24px',
              minWidth: '400px'
            }
          }}
        >
          <DialogTitle id="booking-success-dialog" sx={{ textAlign: 'center', fontWeight: 'bold', p: 0 }}>
            {t('booking_success_title')}
          </DialogTitle>

          <DialogContent sx={{ textAlign: 'left', mt: 1 }}>
            <Box sx={{ width: 320, fontSize: 14, color: '#444' }}>
              {(() => {
                let currentTime = selectedTime;

                const selectedTherapists = selectedTherapist[0]?.id === 0
                  ? (duo && therapists.length >= 2
                    ? [therapists[0], therapists[1]]
                    : !duo && therapists.length >= 1
                      ? [therapists[0]]
                      : [{ id: 0 }]
                  )
                  : selectedTherapist;

                if (duo && selectedTherapists.length !== 2) {
                  notify.warn('Veuillez sélectionner deux thérapeutes pour un duo.');
                  return null;
                } else if (!duo && selectedTherapists.length !== 1) {
                  notify.warn('Veuillez sélectionner un thérapeute.');
                  return null;
                }

                return selectedTherapists.map((p, indx) => {
                  const isSingleTherapist = selectedTherapists.length === 1;

                  if (isSingleTherapist) {
                    return (
                      <React.Fragment key={indx}>
                        {translatedSelectedServices.map((service, serviceIndex) => {
                          const startTime = currentTime;
                          const endTime = addMinutesToTime(startTime, Number(service.product.duration));
                          currentTime = endTime;

                          return (
                            <React.Fragment key={serviceIndex}>
                              {serviceIndex === 0 && (
                                <Box sx={{ display: 'flex', alignItems: 'left', mb: 1 }}>
                                  <img
                                    style={{ width: 60, height: 60, marginRight: 16, borderRadius: 30 }}
                                    src={p.media?.[0].original_url}
                                  />
                                  <Box>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: 16 }}>
                                      {p.firstname}
                                    </Typography>
                                    <Box sx={{ display: 'flex', alignItems: 'left' }}>
                                      <StarIcon fontSize="small" style={{ color: "#F0C419" }} />
                                      <Typography sx={{ ml: 0.5 }}>
                                        {p.extra.rating ?? 5}/5
                                      </Typography>
                                    </Box>
                                  </Box>
                                </Box>
                              )}

                              <Typography
                                sx={{
                                  m: 1,
                                  borderBottom: '1px solid #ccc',
                                  p: '8px 0',
                                }}
                              >
                                {getServiceDisplayTitle(service) + ' - ' + service.product.duration + ' min'}
                              </Typography>

                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  borderBottom: '1px solid #ccc',
                                  m: 1,
                                  fontWeight: 'bold',
                                  fontSize: 16,
                                  p: '8px 0',
                                }}
                              >
                                <Typography>
                                  {formatSelectedDate(selectedDate)} {startTime} – {endTime}
                                </Typography>
                                <Typography fontWeight={'bold'}>
                                  {service.product?.price || '—'} CHF
                                </Typography>
                              </Box>
                            </React.Fragment>
                          );
                        })}
                      </React.Fragment>
                    );
                  } else {
                    const serviceIndex = indx % translatedSelectedServices.length;
                    const service = translatedSelectedServices[serviceIndex];

                    return (
                      <React.Fragment key={indx}>
                        <Box sx={{ display: 'flex', alignItems: 'left', mb: 1 }}>
                          <img
                            style={{ width: 60, height: 60, marginRight: 16, borderRadius: 30 }}
                            src={p.media?.[0].original_url}
                          />
                          <Box>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: 16 }}>
                              {p.firstname}
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'left' }}>
                              <StarIcon fontSize="small" style={{ color: "#F0C419" }} />
                              <Typography sx={{ ml: 0.5 }}>
                                {p.extra.rating ?? 5}/5
                              </Typography>
                            </Box>
                          </Box>
                        </Box>

                        <Typography
                          sx={{
                            m: 1,
                            borderBottom: '1px solid #ccc',
                            p: '8px 0',
                          }}
                        >
                          {getServiceDisplayTitle(service) + ' - ' + service.product.duration + ' min'}
                        </Typography>

                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            borderBottom: '1px solid #ccc',
                            m: 1,
                            fontWeight: 'bold',
                            fontSize: 16,
                            p: '8px 0',
                          }}
                        >
                          <Typography>
                            {formatSelectedDate(selectedDate)} {selectedTime} - {addMinutesToTime(selectedTime, Number(service.product.duration))}
                          </Typography>
                          <Typography fontWeight={'bold'}>
                            {service.product?.price || '—'} CHF
                          </Typography>
                        </Box>
                      </React.Fragment>
                    );
                  }
                });
              })()}
            </Box>

            <Box
              mb={2}
              sx={{
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#fff',
                border: '1px solid #ccc',
                borderRadius: '12px',
                overflow: 'hidden',
                paddingRight: '4px',
                height: '40px',
                width: 'max-content',
                margin: 'auto',
              }}
            >
              <TextField
                placeholder="Indiquer un code promo"
                variant="standard"
                InputProps={{
                  disableUnderline: true,
                  sx: {
                    pl: 2,
                    m: 1,
                    flex: 1,
                    fontSize: '14px',
                    color: '#333',
                  },
                }}
                value={promoCode}
                onChange={(e) => setPromoCode(e.target.value)}
              />

              <Button
                onClick={handlePromoCodeSubmit}
                variant="text"
                sx={{
                  borderRadius: '8px',
                  fontWeight: 'normal',
                  textTransform: 'none',
                  color: '#393d44',
                  background: '#f4f4f4',
                  minWidth: '80px',
                  height: '32px',
                  '&:hover': {
                    background: '#e0e0e0',
                  },
                }}
              >
                Valider
              </Button>
            </Box>
            {alertMessage && <div className="alert">{alertMessage}</div>}

            <Typography
              marginTop={3}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '0 8px',
              }}
            >
              <span>Total (TVA incluse)</span>
              <strong>{discountedPrice?.toFixed(2)} CHF</strong>
            </Typography>
          </DialogContent>


          <DialogContent sx={{ justifyContent: 'center', m: 'auto', p: 0 }}>
            <Button
              variant="contained"
              disabled={isBookingSubmitting}
              onClick={() => {
                setBookingSuccess(false);
                setBookingIdempotencyKey(null);
              }}
              sx={{
                borderRadius: '8px',
                textTransform: 'none',
                fontWeight: 'bold',
                margin: '0 5px',
                border: '1px solid #393d44',
                background: '#f4f4f4',
                color: '#393d44',
                maxWidth: '100px'
              }}
            >
              {t('close')}
            </Button>

            <Button
              variant="contained"
              onClick={(e) => handleSubmitPopUp(e)}
              disabled={isBookingSubmitting}
              sx={{
                borderRadius: '8px',
                textTransform: 'none',
                fontWeight: 'bold',
                background: '#393d44',
                margin: '0 5px',
                color: '#faef9b',
                maxWidth: '100px',
                '&.Mui-disabled': {
                  background: '#6b6f78',
                  color: '#f5efbd'
                }
              }}
            >
              {isBookingSubmitting ? '...' : t('next')}
            </Button>
          </DialogContent>
        </Dialog>
      )}

    </>
  );
}
export default ChooseTherapist;
